"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const CLOUDINARY_BACKGROUND_PATH = 'https://res.cloudinary.com/mixtiles/image/upload/q_auto:best/wallDecorationPrototype';
const ART_SETS_BACKGROUND_IMAGES = {
    VASE: `${CLOUDINARY_BACKGROUND_PATH}/vase.jpg`,
    ARMCHAIR: `${CLOUDINARY_BACKGROUND_PATH}/armchair.jpg`,
    WINDOW_SINGLE: `${CLOUDINARY_BACKGROUND_PATH}/window_single.jpg`,
    DESK_TWINS: `${CLOUDINARY_BACKGROUND_PATH}/desk_twins.jpg`,
    DESK_ZOOMEDOUT: `${CLOUDINARY_BACKGROUND_PATH}/desk_zoomedout.jpg`,
    GREY_COUCH_ZOOMED: `${CLOUDINARY_BACKGROUND_PATH}/greycouch_zoomed.jpg`,
    GREY_COUCH_BLANKET: `${CLOUDINARY_BACKGROUND_PATH}/greycouch_blanket.jpg`,
    WHITECOUCH_PLANT_ZOOM: `${CLOUDINARY_BACKGROUND_PATH}/whitecouch_plant_zoom.jpg`,
    WHITECOUCH_PLANT_ZOOMOUT: `${CLOUDINARY_BACKGROUND_PATH}/whitecouch_plant_zoomout.jpg`,
    DOOR_LAYOUTS: `${CLOUDINARY_BACKGROUND_PATH}/Door_Layouts.jpg`,
    STAIRWAY_LAYOUTS: `${CLOUDINARY_BACKGROUND_PATH}/Stairway_Layouts.jpg`,
    DESK_LAYOUTS: `${CLOUDINARY_BACKGROUND_PATH}/Desk_Layouts.jpg`,
    HALL_LAYOUTS: `${CLOUDINARY_BACKGROUND_PATH}/Hall_Layouts.jpg`,
    BENCH_LAYOUTS: `${CLOUDINARY_BACKGROUND_PATH}/Bench_Layouts.jpg`,
    COUCH_LAYOUTS: `${CLOUDINARY_BACKGROUND_PATH}/Couch_Layouts.jpg`,
    COUCH2_LAYOUTS: `${CLOUDINARY_BACKGROUND_PATH}/Couch2_Layouts.jpg`,
    DINING_LAYOUTS: `${CLOUDINARY_BACKGROUND_PATH}/Dining_Layouts.jpg`
};
exports.default = ART_SETS_BACKGROUND_IMAGES;
//# sourceMappingURL=art-sets-backgrounds.js.map